import { Badge } from "@/components/ui/badge";
import { getScoreColor, getGradeColor } from "./analyticsUtils";

export function ScoreGauge({ score, grade }) {
  if (score === null || score === undefined) {
    return (
      <div className="flex flex-col items-center py-8">
        <div className="w-32 h-32 rounded-full border-8 border-gray-200 flex items-center justify-center">
          <span className="text-gray-400 text-sm">Sem dados</span>
        </div>
      </div>
    );
  }

  const color = getScoreColor(score);
  const circumference = 2 * Math.PI * 56;
  const progress = (score / 100) * circumference;

  return (
    <div className="flex flex-col items-center" data-testid="score-gauge">
      <div className="relative w-36 h-36">
        <svg className="w-full h-full transform -rotate-90" viewBox="0 0 128 128">
          <circle cx="64" cy="64" r="56" fill="none" stroke="#e5e7eb" strokeWidth="12" />
          <circle
            cx="64" cy="64" r="56" fill="none"
            stroke={color} strokeWidth="12" strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            className="transition-all duration-1000"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-4xl font-black" style={{ color }}>{score}</span>
          <span className="text-sm text-gray-500">/100</span>
        </div>
      </div>
      <Badge
        className="mt-3 text-base px-4 py-1 font-bold"
        style={{ backgroundColor: getGradeColor(grade), color: "#fff" }}
      >
        Classe {grade}
      </Badge>
    </div>
  );
}
